import React, { useCallback, useEffect, useRef } from "react";

export function usePreventScrolling<T extends HTMLElement>({
  ms = 300,
}: { ms?: number } = {}) {
  const wheelTimeout = useRef<NodeJS.Timeout | null>(null);

  const onWheel: React.WheelEventHandler<T> = useCallback(() => {
    // while wheel is moving, do not release the lock
    if (wheelTimeout.current) {
      clearTimeout(wheelTimeout.current);
    }

    // flag indicating to lock page scrolling (setTimeout returns a number)
    wheelTimeout.current = setTimeout(() => {
      wheelTimeout.current = null;
    }, ms);
  }, [ms]);

  // block the body from scrolling (or any other element)
  useEffect(() => {
    const cancelWheel: (this: HTMLElement, event: WheelEvent) => any = (
      event,
    ) => wheelTimeout.current && event.preventDefault();
    document.body.addEventListener("wheel", cancelWheel, {
      passive: false,
    });
    return () => {
      document.body.removeEventListener("wheel", cancelWheel);
    };
  }, []);

  return onWheel;
}
